import { EmailTemplate as Rights } from '../../config/Rights';

import { hasRequestedAccess } from '../../helpers/RoleHelper';

// eslint-disable-next-line import/prefer-default-export
export const userCanUpdateEmailTemplate = () => {
  return hasRequestedAccess(Rights.EmailTemplateUpdate);
};
